/**
 * @author: liaosir
 * @description: 将数据转换为千分位逗号分隔格式
 * @param datasource 需要转换的数据
 * @param data 被转换的数据
 * @returns string
 */

const ToLocaleString = (data: number | undefined) => {
  return data ? data.toLocaleString() : 0;
};

export { ToLocaleString };
